import { render, staticRenderFns } from "./base-layout.vue?vue&type=template&id=1d8a567f"
import script from "./base-layout.vue?vue&type=script&lang=js"
export * from "./base-layout.vue?vue&type=script&lang=js"
import style0 from "./base-layout.vue?vue&type=style&index=0&id=1d8a567f&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports